import { useMutateEntry } from '@utils/component-framework';
import { arrangeZIndexes } from './utils/arrange-z-indexes.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useDeleteLineEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const page = getPageEntryById(entry.data, args.pageId);
    page.lines = page.lines.filter(line => line.id !== args.lineId);

    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete page.items[args.lineId];
    arrangeZIndexes(page);
    return entry;
  });
}

export { useDeleteLineEntryMutation };
//# sourceMappingURL=line.delete.js.map
